export function simplePluralize(inputString: string) {
  return inputString.slice(-1) === 'y'
    ? inputString.slice(0, -1) + 'ies'
    : inputString.slice(-1) === 'x'
    ? inputString + 'es'
    : inputString + 's'
}
